export const noInvalidHyphenOrSpace =
  () =>
  (value: string): boolean => {
    return (
      !value.endsWith(" ") &&
      !value.endsWith("-") &&
      !value.startsWith(" ") &&
      !value.startsWith("-")
    );
  };
